import axios from 'axios'

class PaymentService {
  getPayment = ({ referenceNumber,queryToken }) =>
    axios({
      url: `payments/checkStatus/${referenceNumber}`,
      method: 'GET',
      ...(queryToken) && {
        headers : { Authorization: `Bearer ${queryToken}` }
      }
    })
}

export default new PaymentService()
